var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "set6/icn_verify") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-592.000000, -991.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_thumbs-up_218892",
    transform: "translate(593.000000, 993.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,15.0916585 C8,15.7740012 8.71334792,16 9.57549234,16 L16.3676149,15.9956539 L16.3894967,15.9956539 C17.3873085,15.9435003 18.166302,15.1525044 18.166302,14.2007016 C18.166302,14.0572793 18.1487965,13.9138569 18.1137856,13.7791268 C18.7921225,13.5009744 19.2516411,12.8620931 19.2516411,12.1232508 C19.2516411,11.8798674 19.1991247,11.6451763 19.1028446,11.4235236 C19.654267,11.1019099 20,10.5282206 20,9.8849931 C20,9.39388025 19.7899344,8.93319032 19.4310722,8.5985382 C19.6849015,8.28996287 19.8293217,7.90750331 19.8293217,7.50331309 C19.833698,7.03827703 19.6367615,6.59062549 19.2822757,6.24728111 C18.9146608,5.89089833 18.4070022,5.68663016 17.8905908,5.68663016 L13.273523,5.68663016 L13.4923414,3.98294664 C13.5273523,3.77867847 13.536105,3.57006416 13.5404814,3.36144985 C13.5973742,0.705963556 11.9080963,-0.584837473 10.5426696,0.253965889 L10.3938731,0.375657569 L10.6039387,3.07895131 C10.6126915,3.19195072 10.6039387,3.30495014 10.5776805,3.41360343 C10.5514223,3.52225671 10.5032823,3.62656387 10.4420131,3.72217876 L8,7.82927294 L8,15.0916585 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.349016854,18 L6.65098315,18 C6.84269663,18 7,17.8594025 7,17.6880492 L7,8.31195079 C7,8.14059754 6.84269663,8 6.65098315,8 L0.349016854,8 C0.157303371,8 0,8.14059754 0,8.31195079 L0,17.6880492 C0,17.8594025 0.157303371,18 0.349016854,18 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.8d7554c2.svg";
export { ForwardRef as ReactComponent };